<template>
  <v-page>
    <toolbar fixed>
      <template v-slot:left>
        <span class="v-toolbar__text">{{
          $t("pages.account.support.supportTitle")
        }}</span>
      </template>
    </toolbar>

    <list class="mt-1" boxed heading="Support">
      <list-item
        chevron
        @click="() => emailAccount('Support Request from FitterApp')"
      >
        <template slot="left">
          <v-icon icon="chat_bubble_outline" />
        </template>
        <div class="v-list-item__title --centered ml-1">
          {{ $t("pages.account.support.supportGetHelp", { appName: appName }) }}
        </div>
      </list-item>
      <list-item
        chevron
        @click="() => emailFitter('Problem with app from FitterApp')"
      >
        <template slot="left">
          <v-icon icon="phonelink_erase" />
        </template>
        <div class="v-list-item__title --centered ml-1">
          {{ $t("pages.account.support.supportProblem") }}
        </div>
      </list-item>
      <list-item
        chevron
        @click="() => emailAccount('Billing Query from FitterApp')"
      >
        <template slot="left">
          <v-icon icon="attach_money" />
        </template>
        <div class="v-list-item__title --centered ml-1">
          {{ $t("pages.account.support.supportQuestionBilling") }}
        </div>
      </list-item>
      <list-item chevron @click="requestAccountDeletion">
        <template slot="left">
          <v-icon icon="person_remove" />
        </template>
        <div class="v-list-item__title --centered ml-1">
          {{ $t("pages.account.support.supportQuestionData") }}
        </div>
      </list-item>
    </list>

    <alert-dialog
      :title="$t('pages.account.support.supportEmail')"
      :show="requestedHelp"
      :actions="[
        { title: $t('pages.account.support.supportCopyEmail'), callback: copy }
      ]"
      @close="() => (requestedHelp = false)"
      centered
    >
      {{ supportEmail }}
    </alert-dialog>

    <input
      ref="emailInput"
      :value="supportEmail"
      type="text"
      class="copy-input"
    />
  </v-page>
</template>

<script>
import { mapState, mapGetters } from "vuex"

import EventBus, { EVENTS } from "@/lib/event-bus"
import copy from "@/lib/copy"

import Toolbar from "@/components/Toolbar"
import List from "@/components/List"
import ListItem from "@/components/ListItem"
import AlertDialog from "@/components/AlertDialog"

const FITTER_SUPPORT_EMAIL = "support@fitterapp.co"

export default {
  components: {
    Toolbar,
    List,
    ListItem,
    AlertDialog
  },

  computed: {
    ...mapState(["global"]),
    ...mapGetters(["appName"])
  },

  data() {
    return {
      requestedHelp: false,
      supportEmail: FITTER_SUPPORT_EMAIL
    }
  },

  methods: {
    emailSupport(subject, cc = null) {
      const ccString = cc ? `&cc=${cc}` : ""

      window.location.href = `mailto:${this.supportEmail}?subject=${subject}${ccString}`
    },

    requestAccountDeletion() {
      EventBus.$emit(EVENTS.TRIGGER_FORM, {
        formId: process.env.VUE_APP_ACCOUNT_DELETION_FORM_ID
      })
    },

    emailAccount(subject) {
      this.supportEmail = this.global?.account.email
      this.emailSupport(subject)
      this.requestedHelp = true
    },

    emailFitter(subject) {
      this.supportEmail = FITTER_SUPPORT_EMAIL
      this.emailSupport(subject)
      this.requestedHelp = true
    },

    copy() {
      copy(this.$refs.emailInput).then(() => {
        this.requestedHelp = false

        this.$notify(this.$t("pages.account.support.supportCopiedEmail"))
      })
    }
  }
}
</script>
